import LdChangeProfilePictureModal from 'lion-vue-shared/components/LdChangeProfilePictureModal';
import { HC_PROPS, initHCProps } from '../index';

export { initHCProps, HC_PROPS };
export default LdChangeProfilePictureModal;
